<kp-done-animation *ngIf="showDoneAnimation" (animationStateChange)="completeQuestionSet($event)"></kp-done-animation>
<div class="question-set-container" [ngClass]="{ 'embedded-now': isEmbeddedNow }" *ngIf="currentQuestion">
  <kp-question
    *ngIf="!showDoneAnimation"
    [isEmbedded]="isEmbeddedNow"
    [question]="currentQuestion"
    (updatedQuestionAnswer)="updateAnswer($event)"
    (canAdvance)="isQuestionAnswered = $event"></kp-question>
  <div class="bottom-nav-container" *ngIf="!isEmbeddedNow && !showDoneAnimation">
    <kp-bottom-arrow-nav
      *ngIf="currentQuestion?.inputType !== questionType.image_icon_selection"
      [showsNextButton]="isQuestionAnswered"
      [disableNextButton]="isSubmitted"
      [showsSkip]="!currentQuestion?.settings?.required && !isQuestionAnswered"
      [showLargeFade]="false"
      (nextClick)="onSubmit()"></kp-bottom-arrow-nav>
  </div>
</div>
